import { render, staticRenderFns } from "./IconGroupLight.vue?vue&type=template&id=1f973d35&"
import script from "./IconGroupLight.vue?vue&type=script&lang=js&"
export * from "./IconGroupLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports